<template>
  <div class="bar-chart-main">
    <div class="title">
      {{ chartTitle }}
      <div class="bar-indicator" v-if="matchBarLineLegend.length > 0"></div>
      <div v-if="matchBarLineLegend.length > 0">{{ matchBarLineLegend[0] }}</div>
      <div class="line-indicator" v-if="matchBarLineLegend.length > 0"></div>
      <div v-if="matchBarLineLegend.length > 0">{{ matchBarLineLegend[1] }}</div>
    </div>
    <div class="chart-container" v-if="items.length > 0">
      <div class="chart-area" id="chartArea">
        <svg :id="`svgContainer${chartID}`" height="100%" width="100%">
          <g :id="`gridContainer${chartID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1" stroke-dasharray="3">
          </g>
        </svg>
        <div class="tooltip tooltip-hidden" :id="`tooltip${chartID}`" :style="{ width: `${tooltipWidth}px`, top: 0 }">Test</div>
      </div>
      <div :style="{ minWidth: showLegend ? '100px' : '0', maxWidth: showLegend ? '150px' : '0', padding: showLegend ? '5px' : '0' }" class="legend-area" :id="`legend${chartID}`"></div>
    </div>
    <div class="empty-message" v-else>
      {{ emptyMessage }}
    </div>
    <div :id="`cMenu${chartID}`" class="context-menu context-menu-hide" :style="{ width: `${contextMenuWidth}px` }">
      <div class="context-menu-items" v-for="c in contextMenu" :key="c" @click="contextMenuClicked(c)">{{ c }} for {{ contextDetails ? contextDetails.item : '' }} ({{ contextDetails ? contextDetails.data[xAxisKey] : '' }})</div>
      <div class="context-menu-divider"></div>
      <div class="context-menu-items" @click="contextMenuClicked('')">Close</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
var top, left, bottom, right, width, height, itemCount;
var barCount = 1;
var verticalLinePosition;
var horizontalLinePosition;
var yAxis;
var xAxis;
var xMidPoint;
var yMidPoint;
var maxRow = 12;
var maxValue = 0;

export default {
  components: {
  },
  props: {
    contextDetails: { type: Object, default: function() { return null } },
    hiddenChart: { type: Array, default: function() { return [] } },

    // Public properties
    barKeys: { type: Array, default: function() { return [] } }, // The keys of the object that will represent in bar chart, multiple keys will represent multiple bars
    lineKeys: { type: Array, default: function() { return [] } }, // The keys of the object that will represent in line chart, multiple keys will represent multiple lines
    xAxisKey: { type: String, default: '' }, // The key of the items to show in the x axis labels
    items: { type: Array, default: function() { return [] } }, // The items in the chart
    colors: { type: Array, default: function() { return [] } }, // The default colors are obtain from chartColors.js but you can override this if you want to
    chartID: { type: String, default: 'barLine' }, // Compulsory if you have multiple charts in one page
    chartTitle: { type: String, default: 'Chart Title' }, // The title of the chart
    emptyMessage: { type: String, default: 'No items to show' }, // Customize the message to show when the chart is empty
    tooltipFormat: { type: String, default: '' }, // Eg: The item [key] has [value] value for [anyKey], where key = legend, value = value of the hovered chart, anyKey = any key from the object to show when hover
    tooltipWidth: { type: String, default: '100' }, // The width of the tooltip
    contextMenu: { type: Array, default: function() { return [] } }, // Add your context menu in an array of strings to show the context menu when the chart is clicked
    contextMenuWidth: { type: String, default: '100' }, // The width of the context menu
    yAxisWidth: { type: String, default: '40' }, // Set the width of the yAxis
    showLegend: { type: Boolean, default: true }, // Set to false to hide the legend
    isHorizontal: { type: Boolean, default: false }, // Set to true if you would like to show the bar chart in horizontal (Only supports bar chart)
    matchBarLine: { type: Boolean, default: false }, // Set to true if your line and bar chart is sharing the same legend
    matchBarLineLegend: { type: Array, default: function() { return [] } }, // Important if matchBarLine is set to true to indicate what is the bar chart and line chart for. Consists of 2 string only, 1st string will indicate the bar chart and the 2nd string will indicate the line chart

    // Public events
    // @contextMenuClicked - return 3 items, context menu name, legend name and the object of the chart that is clicked
  },
  methods: {
    createLine: function(x1, x2, y1, y2, stroke, strokeWidth) {
      var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', x1);
      line.setAttribute('x2', x2);
      line.setAttribute('y1', y1);
      line.setAttribute('y2', y2);

      if (stroke) {
        line.setAttribute('stroke', stroke);
        line.setAttribute('stroke-dasharray', 0);
      }

      if (strokeWidth) {
        line.setAttribute('stroke-width', strokeWidth);
      }

      return line;
    },
    createBarChart: function() {
      var barList = [];
      if (!this.isHorizontal) {
        var highestValue = yAxis[yAxis.length - 1];
        var valuePerPixel = (bottom - top) / highestValue;

        xMidPoint.forEach((m, i) => {
          var currentBar = [];
          var item = this.items[i];
          var x = m;

          var startX = x;
          this.barKeys.forEach((b, bi) => {
            if (this.hiddenChart.includes(b)) {
              return;
            }
            var height = valuePerPixel * item[b];

            var bar = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            bar.setAttribute('x', x);
            bar.setAttribute('y', bottom - height);
            bar.setAttribute('width', '10');
            bar.setAttribute('stroke', 'none');
            bar.setAttribute('height', height);
            bar.setAttribute('fill', this.colors[bi]);
            bar.setAttribute('hoverDetails', JSON.stringify(item));

            bar.addEventListener('mouseover', this.chartHoverIn);
            bar.addEventListener('mouseout', this.chartHoverOut);
            bar.addEventListener('mousemove', this.chartHoverMove);
            if (this.contextMenu.length > 0) {
              bar.setAttribute('cursor', 'pointer');
              bar.addEventListener('click', this.chartClicked);
            }

            if (bi < this.barKeys.length - 1) {
              x += 13;
            } else {
              x += 10;
            }

            currentBar.push(bar);
          });
          var endX = x;

          currentBar.forEach((c) => {
            var currentX = c.getAttribute('x');
            c.setAttribute('x', currentX - ((endX - startX) / 2));
            barList.push(c);
          });
        });
      } else {
        var valueGap = xAxis[xAxis.length - 1] - xAxis[xAxis.length - 2];
        var highestValue = xAxis[xAxis.length - 1];
        var valuePerPixel = (right - left) / (highestValue + valueGap);
        
        yMidPoint.forEach((m, i) => {
          var currentBar = [];
          var item = this.items[i];
          var y = m;

          var startY = y;
          this.barKeys.forEach((b, bi) => {
            if (this.hiddenChart.includes(b)) {
              return;
            }
            var width = valuePerPixel * item[b];

            var bar = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            bar.setAttribute('x', this.yAxisWidth);
            bar.setAttribute('y', m);
            bar.setAttribute('width', width);
            bar.setAttribute('stroke', 'none');
            bar.setAttribute('height', '10');
            bar.setAttribute('fill', this.colors[bi]);
            bar.setAttribute('hoverDetails', JSON.stringify(item));

            bar.addEventListener('mouseover', this.chartHoverIn);
            bar.addEventListener('mouseout', this.chartHoverOut);
            bar.addEventListener('mousemove', this.chartHoverMove);
            if (this.contextMenu.length > 0) {
              bar.setAttribute('cursor', 'pointer');
              bar.addEventListener('click', this.chartClicked);
            }

            if (bi < this.barKeys.length - 1) {
              y += 13;
            } else {
              y += 10;
            }

            currentBar.push(bar);
          });
          var endY = y;

          currentBar.forEach((c) => {
            var currentY = c.getAttribute('y');
            c.setAttribute('y', currentY - ((endY - startY) / 2));
            barList.push(c);
          });
        });
      }

      return barList;
    },
    createLineChart: function(grid) {
      var highestValue = yAxis[yAxis.length - 1];
      var valuePerPixel = (bottom - top) / highestValue;

      var pointPosition = [];

      this.lineKeys.forEach((l) => {
        var points = [];
        if (!this.hiddenChart.includes(l)) {
          this.items.forEach((t, i) => {
            var yPos = bottom - (valuePerPixel * t[l]);
            var xPos = xMidPoint[i];
            
            points.push([xPos, yPos]);
          });
        }
        pointPosition.push(points);
      });

      var index = 0;

      if (!this.matchBarLine) {
        index = this.barKeys.length;
      }
      pointPosition.forEach((p) => {
        for (var i = 1; i < p.length; i++) {
          var x1 = p[i - 1][0];
          var y1 = p[i - 1][1];
          var x2 = p[i][0];
          var y2 = p[i][1];

          var line = this.createLine(x1, x2, y1, y2, this.colors[index], 2);
          if (this.matchBarLine) {
            line.setAttribute('stroke-dasharray', 10);
          }
          grid.appendChild(line);
        }
        index++;
      });
      
      index = 0;
      if (!this.matchBarLine) {
        index = this.barKeys.length;
      }
      pointPosition.forEach((point) => {
        point.forEach((p, i) => {
          var item = this.items[i];
          var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          circle.setAttribute('cx', p[0]);
          circle.setAttribute('cy', p[1]);
          circle.setAttribute('r', '5');
          circle.setAttribute('fill', this.colors[index]);
          circle.setAttribute('stroke', 'white');
          circle.setAttribute('stroke-dasharray', 0);
          circle.setAttribute('hoverDetails', JSON.stringify(item));

          circle.addEventListener('mouseover', this.chartHoverIn);
          circle.addEventListener('mouseout', this.chartHoverOut);
          circle.addEventListener('mousemove', this.chartHoverMove);
          if (this.contextMenu.length > 0) {
            circle.setAttribute('cursor', 'pointer');
            circle.addEventListener('click', this.chartClicked);
          }

          grid.appendChild(circle);
        });
        index++;
      });
    },
    createGridOuterBorder: function(grid) {
      grid.appendChild(this.createLine(left, right, top, top));
      grid.appendChild(this.createLine(right, right, top, bottom));
      grid.appendChild(this.createLine(left, right, bottom, bottom));
      grid.appendChild(this.createLine(left, left, top, bottom));
    },
    createLegendItem: function(color, text) {
      var legendItem = document.createElement('div');
      legendItem.className = 'legend-item';

      var legendColor = document.createElement('div');
      legendColor.className = 'legend-color';
      legendColor.style.backgroundColor = color;
      legendColor.style.borderColor = color;
      legendColor.addEventListener('click', this.legendClicked);

      var legendText = document.createElement('div');
      legendText.innerHTML = text;
      legendText.style.opacity = 0.75;

      legendItem.appendChild(legendColor);
      legendItem.appendChild(legendText);

      return legendItem;
    },
    // Creating the horizontal lines and yAxis labels for vertical bar
    createInnerHorizontalLine: function(grid) {
      var newBottom = bottom;

      horizontalLinePosition = [];
      horizontalLinePosition.push(bottom);

      if (!this.isHorizontal) {
        var steps = 0;
        var minSteps = 0;

        var increment = [ 1, 2, 5 ];
        var multiply = 1;
        var index = 0;

        while (minSteps <= maxValue) {
          if (index == 3) {
            index = 0;
            multiply++;
          }

          var tenthPower = Math.pow(10, multiply);
          minSteps = increment[index] * tenthPower;

          index++;
        }

        minSteps /= 10;

        yAxis = [];
        while (steps <= maxValue) {
          steps += minSteps;
          yAxis.push(steps);
        }
        
        var spacing = height / yAxis.length;

        for (var i = 0; i < yAxis.length - 1; i++) {
          newBottom -= spacing;
          grid.appendChild(this.createLine(left, right, newBottom, newBottom));
          horizontalLinePosition.push(newBottom);
        }

        yAxis.splice(0, 0, 0);

        this.addYAxisLabel(grid, yAxis);
      } else {
        var spacing = height / itemCount;

        for (var i = 0; i < itemCount - 1; i++) {
          newBottom -= spacing;
          grid.appendChild(this.createLine(left, right, newBottom, newBottom));
          horizontalLinePosition.push(newBottom);
        }

        this.addYAxisLabel(grid);
      }
      
      horizontalLinePosition.push(top);

      yMidPoint = [];
      for (var i = 1; i < horizontalLinePosition.length; i++) {
        yMidPoint.push((horizontalLinePosition[i] + horizontalLinePosition[i - 1]) / 2);
      }
    },
    addYAxisLabel: function(grid, yaxisValues) {
      if (!this.isHorizontal) {
        for (var i = 0; i < yaxisValues.length; i++) {
          var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
          fObject.setAttribute('width', this.yAxisWidth);
          fObject.setAttribute('height', '15');
          fObject.setAttribute('x', '0');
          fObject.setAttribute('y', horizontalLinePosition[i] - 7.5);

          var span = document.createElement('span');
          span.className = 'yaxis-label';
          span.innerHTML = yaxisValues[i];

          fObject.appendChild(span);
          grid.appendChild(fObject);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
          fObject.setAttribute('width', this.yAxisWidth);
          fObject.setAttribute('height', '15');
          fObject.setAttribute('x', '0');
          fObject.setAttribute('y', horizontalLinePosition[i] - 15);

          var span = document.createElement('span');
          span.className = 'yaxis-label';
          span.innerHTML = this.items[i][this.xAxisKey];

          fObject.appendChild(span);
          grid.appendChild(fObject);
        }
      }
    },
    // Creating the horizontal lines and yAxis labels for vertical bar
    // Creating the vertical lines and xAxis labels
    createInnerVerticalLine: function(grid) {
      var newLeft = left;
      verticalLinePosition = [];
      verticalLinePosition.push(left);

      if (!this.isHorizontal) {
        var spacing = width / itemCount;

        if (spacing <= (this.barKeys.length * 13)) {
          spacing = this.barKeys.length * 13;
        }

        for (var i = 0; i < itemCount - 1; i++) {
          newLeft += spacing;
          grid.appendChild(this.createLine(newLeft, newLeft, top, bottom));
          verticalLinePosition.push(newLeft);
        }
        
        verticalLinePosition.push(right);
      } else {
        var steps = 0;
        var minSteps = 0;

        var increment = [ 1, 2, 5 ];
        var multiply = 1;
        var index = 0;

        while (minSteps <= maxValue) {
          if (index == 3) {
            index = 0;
            multiply++;
          }

          var tenthPower = Math.pow(10, multiply);
          minSteps = increment[index] * tenthPower;

          index++;
        }

        minSteps /= 10;

        xAxis = [];
        while (steps <= maxValue) {
          steps += minSteps;
          xAxis.push(steps);
        }

        var spacing = width / (xAxis.length + 1);

        if (spacing < 10) { 
          spacing = 10;
        }

        for (var i = 0; i < xAxis.length; i++) {
          newLeft += spacing;
          grid.appendChild(this.createLine(newLeft, newLeft, top, bottom));
          verticalLinePosition.push(newLeft);
        }
        
        verticalLinePosition.push(right);
      }

      this.addXAxisLabel(grid, verticalLinePosition);
      
      xMidPoint = [];
      for (var i = 1; i < verticalLinePosition.length; i++) {
        xMidPoint.push((verticalLinePosition[i] + verticalLinePosition[i - 1]) / 2);
      }
    },
    addXAxisLabel: function(grid, position) {
      if (!this.isHorizontal) {
        if (!this.xAxisKey) {
          console.log('xAxisKey is not defined');
          return;
        }

        this.items.forEach((t, i) => {
          var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
          fObject.setAttribute('width', position[i + 1] - position[i]);
          fObject.setAttribute('height', '15');
          fObject.setAttribute('x', position[i] - 15);
          fObject.setAttribute('y', bottom + 15);
          fObject.style = 'overflow: visible'

          var span = document.createElement('span');
          span.className = 'xaxis-label';
          span.innerHTML = t[this.xAxisKey];

          fObject.appendChild(span);
          grid.appendChild(fObject);
        });
      } else {
        var width = position[1] - position[0];

        var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
        fObject.setAttribute('width', width);
        fObject.setAttribute('height', '15');
        fObject.setAttribute('x', this.yAxisWidth - (width / 2));
        fObject.setAttribute('y', bottom);
        fObject.style = 'overflow: visible'

        var span = document.createElement('span');
        span.className = 'xaxis-label';
        span.innerHTML = '0';
        span.style.transform = 'rotate(0deg)';

        fObject.appendChild(span);
        grid.appendChild(fObject);

        xAxis.forEach((x, i) => {
          var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
          fObject.setAttribute('width', width);
          fObject.setAttribute('height', '15');
          fObject.setAttribute('x', position[i] + (width / 2));
          fObject.setAttribute('y', bottom);
          fObject.style = 'overflow: visible'

          var span = document.createElement('span');
          span.className = 'xaxis-label';
          span.innerHTML = x;
          span.style.transform = 'rotate(0deg)';

          fObject.appendChild(span);
          grid.appendChild(fObject);
        });
      }
    },
    // Creating the vertical lines and xAxis labels
    // Chart hover methods
    chartHoverIn: function(e) {
      var tooltip = document.getElementById(`tooltip${this.chartID}`);
      var details = JSON.parse(e.target.getAttribute('hoverDetails'));
      var legendContainer = document.getElementById(`legend${this.chartID}`);

      var isBar = e.target.getAttribute('cx') == null;

      var fillColor = e.target.getAttribute('fill');
      var hoverColor = this.colors.filter((c) => { return c.toUpperCase() == fillColor.toUpperCase() });
      var legendIndex = this.colors.indexOf(hoverColor[0]);

      legendContainer.children[legendIndex].children[1].style.opacity = 1;
      legendContainer.children[legendIndex].children[1].style.fontWeight = 'bold';

      var lineIndex = legendIndex - this.barKeys.length;
      var key = isBar ? this.barKeys[legendIndex] : this.lineKeys[lineIndex >= 0 ? lineIndex : legendIndex];

      if (!this.tooltipFormat) {
        tooltip.innerHTML = `${key}<br />${details[key]}`;
      } else {
        var startIndices = [];
        var endIndices = [];
        for (var i = 0; i < this.tooltipFormat.length; i++) {
          if (this.tooltipFormat[i] == '[') {
            startIndices.push(i + 1);
          } else if (this.tooltipFormat[i] == ']') {
            endIndices.push(i);
          }
        }

        var itemKey = [];
        for (var i = 0; i < startIndices.length; i++) {
          itemKey.push(this.tooltipFormat.substring(startIndices[i], endIndices[i]));
        }

        var format = this.tooltipFormat;

        var format = format.split('[').join('');
        format = format.split(']').join('');
        itemKey.forEach((i) => { 
          format = format.replace(i, '|');
        });

        var item = format.split('|');

        var tooltipText = '';
        var hoverItemIndex = 0;
        item.forEach((i) => {
          tooltipText += i;
          if (itemKey[hoverItemIndex] == 'value') {
            tooltipText += details[key];
          } else if (itemKey[hoverItemIndex] == 'key') {
            tooltipText += key;
          } else {
            var showItem = details[itemKey[hoverItemIndex]];
            tooltipText += `${showItem ? showItem : ''}`;
          }
          hoverItemIndex++;
        });

        tooltip.innerHTML = tooltipText;
      }
      
      tooltip.style.position = 'fixed';
      tooltip.classList.remove('tooltip-hidden');
    },
    chartHoverOut: function(e) {
      document.getElementById(`tooltip${this.chartID}`).classList.add('tooltip-hidden');

      var allLegend = document.getElementById(`legend${this.chartID}`).children;
      Array.from(allLegend).forEach((l) => {
        l.children[1].style.opacity = 0.75;
        l.children[1].style.fontWeight = 'unset';
      });
    },
    chartHoverMove: function(e) {
      var tooltip = document.getElementById(`tooltip${this.chartID}`);
      var height = tooltip.getBoundingClientRect().height;
      var width = tooltip.getBoundingClientRect().width;

      tooltip.style.top = `${e.pageY - height}px`;
      tooltip.style.left = `${e.pageX - width}px`;
    },
    // Chart hover methods
    legendClicked: function(e) {
      var legendContainer = document.getElementById(`legend${this.chartID}`);
      var target = e.target;
      var parent = e.target.parentElement;

      var index = Array.from(legendContainer.children).indexOf(parent);
      
      var background = target.style.backgroundColor;
      if (background == 'transparent') {
        target.style.backgroundColor = target.style.borderColor;
        var barIndex = this.hiddenChart.indexOf(this.barKeys[index]);
        this.hiddenChart.splice(barIndex, 1);
        if (this.matchBarLine) {
          var lineIndex = this.hiddenChart.indexOf(this.lineKeys[index]);
          this.hiddenChart.splice(lineIndex, 1);
        }
      } else {
        target.style.backgroundColor = 'transparent';
        this.hiddenChart.push(index >= this.barKeys.length ? this.lineKeys[this.barKeys.length - index] : this.barKeys[index]);
        if (this.matchBarLine) {
          this.hiddenChart.push(this.lineKeys[index]);
        }
      }

      if (this.isHorizontal) {
        this.onResizeHorizontal();
      } else {
        this.onResize();
      }
    },
    chartClicked: function(e) {
      var contextMenu = document.getElementById(`cMenu${this.chartID}`);
      var legendContainer = document.getElementById(`legend${this.chartID}`);
      var target = e.target;
      var x = e.pageX;
      var y = e.pageY;
      
      var color = target.getAttribute('fill');
      var legendIndex = this.colors.indexOf(color);
      var legend = legendContainer.children[legendIndex].children[1].innerHTML;

      this.contextDetails = { data: JSON.parse(target.getAttribute('hoverDetails')), item: legend };

      contextMenu.classList.remove('context-menu-hide');
      contextMenu.style.top = `${e.pageY}px`;
      contextMenu.style.left = `${e.pageX - this.contextMenuWidth}px`;
    },
    contextMenuClicked: function(item) {
      var contextMenu = document.getElementById(`cMenu${this.chartID}`);
      contextMenu.classList.add('context-menu-hide');

      if (item) {
        this.$emit('contextMenuClicked', item, this.contextDetails.item, this.contextDetails.data);
      }

      this.contextDetails = null;
    },
    onResize: function() {
      if (this.barKeys.length > 0) {
        barCount = this.barKeys.length;
      }

      var minColumnWidth = (barCount * 13);

      document.getElementById(`svgContainer${this.chartID}`).style = `min-width: ${(minColumnWidth * this.items.length) + (Number(this.yAxisWidth) * 2)}px; min-height: ${10 * 12 + 100}px`;

      var container = document.getElementById(`svgContainer${this.chartID}`).getBoundingClientRect();
      var grid = document.getElementById(`gridContainer${this.chartID}`);

      grid.innerHTML = '';

      var allValue = [];
      this.items.forEach((i) => {
        this.barKeys.forEach((b) => {
          if (!this.hiddenChart.includes(b)) {
            allValue.push(i[b]);
          }
        });
      });
      this.items.forEach((i) => {
        this.lineKeys.forEach((l) => {
          if (!this.hiddenChart.includes(l)) {
            allValue.push(i[l]);
          }
        });
      });

      maxValue = Math.max(...allValue);

      itemCount = this.items.length;
      
      top = 10;
      right = container.width - 10;
      bottom = container.height - 50;
      left = Number(this.yAxisWidth);

      width = right - left;
      height = bottom - top;

      this.createGridOuterBorder(grid);
      this.createInnerVerticalLine(grid);
      this.createInnerHorizontalLine(grid);

      if (this.barKeys.length > 0) {
        var bars = this.createBarChart();
        bars.forEach((b) => { grid.appendChild(b) });
      }

      if (this.lineKeys.length > 0) {
        this.createLineChart(grid);
      }

      var legendContainer = document.getElementById(`legend${this.chartID}`);
      if (legendContainer.innerHTML == '') {
        var colorIndex = 0;
        this.barKeys.forEach((b) => {
          legendContainer.appendChild(this.createLegendItem(this.colors[colorIndex], b));
          colorIndex++;
        });
        if (!this.matchBarLine) {
          this.lineKeys.forEach((l) => {
            legendContainer.appendChild(this.createLegendItem(this.colors[colorIndex], l));
            colorIndex++;
          });
        }
      }
    },
    onResizeHorizontal: function() {
      if (this.barKeys.length > 0) {
        barCount = this.barKeys.length;
      }

      var minRowHeight = (barCount * 13);

      if (minRowHeight < 15) {
        minRowHeight = 15;
      }

      document.getElementById(`svgContainer${this.chartID}`).style = `min-height: ${(minRowHeight * this.items.length) + (100)}px; min-width: ${10 * 12 + 100}px`;

      var container = document.getElementById(`svgContainer${this.chartID}`).getBoundingClientRect();
      var grid = document.getElementById(`gridContainer${this.chartID}`);

      grid.innerHTML = '';

      var allValue = [];
      this.items.forEach((i) => {
        this.barKeys.forEach((b) => {
          if (!this.hiddenChart.includes(b)) {
            allValue.push(i[b]);
          }
        });
      });
      this.items.forEach((i) => {
        this.lineKeys.forEach((l) => {
          if (!this.hiddenChart.includes(l)) {
            allValue.push(i[l]);
          }
        });
      });

      maxValue = Math.max(...allValue);

      itemCount = this.items.length;
      
      top = 10;
      right = container.width - 10;
      bottom = container.height - 20;
      left = Number(this.yAxisWidth);

      width = right - left;
      height = bottom - top;

      this.createGridOuterBorder(grid);
      this.createInnerVerticalLine(grid);
      this.createInnerHorizontalLine(grid);

      if (this.barKeys.length > 0) {
        var bars = this.createBarChart();
        bars.forEach((b) => { grid.appendChild(b) });
      }

      var legendContainer = document.getElementById(`legend${this.chartID}`);
      if (legendContainer.innerHTML == '') {
        var colorIndex = 0;
        this.barKeys.forEach((b) => {
          legendContainer.appendChild(this.createLegendItem(this.colors[colorIndex], b));
          colorIndex++;
        });
        this.lineKeys.forEach((l) => {
          legendContainer.appendChild(this.createLegendItem(this.colors[colorIndex], l));
          colorIndex++;
        });
      }
    },
    loadChart: function() {
      setTimeout(() => {
        document.getElementById(`legend${this.chartID}`).innerHTML = '';
        if (this.isHorizontal) {
          this.onResizeHorizontal();
        } else {
          this.onResize();
        }
      }, 100);
    }
  },
  mounted() {
    if (this.colors.length == 0) {
      this.colors = this.$chartColors.getColors();
    }

    if (this.isHorizontal) {
      window.removeEventListener('resize', this.onResize);
      window.addEventListener('resize', this.onResizeHorizontal);
    } else {
      window.removeEventListener('resize', this.onResizeHorizontal);
      window.addEventListener('resize', this.onResize);
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.bar-chart-main {
  // background-color: blue;
  height: 100%;
  width: 100%;
  font-size: 12px;

  > .title {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    text-align: center;

    > .bar-indicator, > .line-indicator {
      height: 10px;
      width: 50px;
      background: gray;
      margin: 0 5px;
      margin-left: 15px;
    }

    > .line-indicator {
      height: 3px;
      background: repeating-linear-gradient(90deg, gray, gray 5px, transparent 5px, transparent 10px);
    }
  }

  > .chart-container {
    height: calc(100% - 20px);
    display: flex;
    align-items: center;
    justify-content: center;

    > .chart-area {
      height: 100%;
      width: 100%;
      overflow: auto;
      // background-color: aqua;
    }

    > .legend-area {
      max-width: 150px;
      min-width: 100px;
      height: 100%;
      font-size: 10px;
      padding: 5px;
      overflow-y: auto;
    }
  }

  > .empty-message {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
</style>

<style>
.yaxis-label, .xaxis-label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 10px;
  padding: 0 3px;
  color: rgb(80, 80, 80);
}

.xaxis-label {
  justify-content: center;
  transform: rotate(-45deg);
  white-space: nowrap;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  position: relative;
}

.legend-color {
  min-height: 15px;
  min-width: 15px;
  margin-right: 5px;
  cursor: pointer;
  border-width: 3px;
  border-style: solid;
  border-radius: 5px;
}
</style>